<template>
  <section class="featured-boxes-area">
    <div class="container">
      <div class="featured-boxes-inner">
        <h3 style="padding-top: 38px;
    margin-bottom: -20px;">Why Choose Us</h3>
        <div class="row m-0">
          <div class="col-lg-3 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <div class="icon" >
                <img style= "width: 200px; height: 120px;" src="assets/img/whychooseus/customer.png" />
              </div>
              <h3>Customer Satisfaction</h3>
              <p>
                {{customerSatisfaction | shorten(showCustomerSatisfaction)}}
                <span 
                class="readMore" 
                v-on:click="showCustomerSatisfaction = !showCustomerSatisfaction">
                <br />{{showCustomerSatisfaction? "hide &#x2190;": "read more &#x2192;"}}
                </span>  
              </p>
              
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <div class="icon" >
                <img style= "width: 200px; height: 120px;" src="assets/img/whychooseus/industry.png" />
              </div>
              <h3>Industry Experience</h3>
              <p>
                {{industryExperience | shorten(showIndustryExperience)}}
                <span 
                class="readMore" 
                v-on:click="showIndustryExperience = !showIndustryExperience">
                <br />{{showIndustryExperience? "hide &#x2190;": "read more &#x2192;"}}
                </span>
              </p>
              
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <div class="icon" >
                <img style= "width: 200px; height: 120px;" src="assets/img/whychooseus/tail.png" />
              </div>
              <h3>Tailored Solutions</h3>
              <p>
                {{tailoredSolution | shorten(showTailoredSolution)}}
                <span 
                class="readMore" 
                v-on:click="showTailoredSolution = !showTailoredSolution">
                <br />{{showTailoredSolution? "hide &#x2190;": "read more &#x2192;"}}
                </span>
              </p>
              
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <div class="icon" >
                <img style= "width: 200px; height: 120px;" src="assets/img/whychooseus/team.png" />
              </div>
              <h3>Team approach</h3>
              <p>
                {{teamApproach | shorten(showTeamApproach)}} 
                <span 
                class="readMore" 
                v-on:click="showTeamApproach = !showTeamApproach">
                <br />{{showTeamApproach? "hide &#x2190;": "read more &#x2192;"}}
                </span>
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => {
    return {
      showCustomerSatisfaction: false,
      showIndustryExperience: false,
      showTailoredSolution: false,
      showTeamApproach: false,
      customerSatisfaction: "As a customer oriented organization, we go above and beyond to get detailed insights as to what our customers want/need. Then we proceed to give them more...",
      industryExperience: "With decades of combined experience in Technology, Finance, Business Strategy, Marketing and Product development, all aspects of our business are expertly covered. We are a mix of technology experts, creative and innovative millennials with business acumen, ever increasing skill and knowledge and technology leadership.",
      tailoredSolution: "iRechargePay as a payment option is limitless! It cuts across all businesses and processes transaction volumes in millions every second. This service is useful to both business owners and customers because to great extent, it solves the problem of failed card payments on POS terminals and instant transaction verification. Here you have a solution that captures all levels of the banked population providing the easiest ways for payments to be made for anything!",
      teamApproach: "Our teams function at peak performance because we collaborate, innovate and achieve synergy through coordinated efforts. Bringing our customers unique products and services.",
              
    }
  },
  computed: {

  },
  filters: {
    shorten: function (value, isset) {
      if(!isset) {
        return value.slice(0,50) +"...";
      }
      return value;
      
    },
  }
};
</script>

<style scoped>
  .readMore {
    text-align: center;
    color: black;
    font-weight: bold;
    cursor: pointer;
  }
</style>